export function track(eventName, payload = {}) {
  // Placeholder for real analytics
  // Keep lightweight
  // eslint-disable-next-line no-console
  console.log("[analytics]", eventName, payload);
}
